const CORONA_COMMAND_PKG = {

    navTitle: "Corona",
    routerName: "CoronaDocs",
    commandsDescription: "Stats, Cases, Overview, etc...",

    commandList: [
        {
            title: "Corona Stats",
            routerRef: "coronastats",
            commandString: "!coronastats <Area>",
            description: "Country or State - common codes for country are - Belgium, France, Germany, etc. -- China and US you need the Province or State.",
            parameters: [
                { name: "Area: ", desc: "The Country/State" },
            ],
            examples: [
                "!coronastats Michigan",
                "!coronastats Germany"
            ],

            type: "Corona",
            shortcuts: ["none"]
        },
        {
            title: "Top Corona Cases",
            routerRef: "topcorona",
            commandString: "!topcorona",
            description: "Top Infected Countries/States",
            parameters: ["none"],
            examples: [
                "!topcorona"
            ],
            type: "Corona",
            shortcuts: ["none"]
        },
        {
            title: "Covid US Map",
            routerRef: "covid",
            commandString: "!covid",
            description: "Map of daily new cases and deaths in the US",
            parameters: ["none"],
            examples: [
                "!covid"
            ],
            type: "Corona",
            shortcuts: ["none"]
        },
        {
            title: "Corona Overview",
            routerRef: "corona",
            commandString: "!corona",
            description: "Corona updates - Summary",
            parameters: ["none"],
            examples: [
                "!corona"
            ],
            type: "Corona",
            shortcuts: ["none"]
        },
    ]
}



export {CORONA_COMMAND_PKG};